// src/services/api/auth.ts
import { apiClient, ApiResponse, AdminUser, AdminRole, AdminPermissions, LoginResponse } from './index';

export const authApi = {
  // Авторизация
  login: (username: string, password: string) =>
    apiClient.post<ApiResponse<LoginResponse>>('/api/admin/auth/login/', {
      username,
      password
    }),

  logout: () =>
    apiClient.post<ApiResponse<{}>>('/api/admin/auth/logout/'),

  getProfile: () =>
    apiClient.get<ApiResponse<{
      user: AdminUser;
      role: AdminRole | null;
      permissions: AdminPermissions;
    }>>('/api/admin/auth/profile/'),

  // Управление пользователями (только для Admin роли)
  getUsers: () =>
    apiClient.get<ApiResponse<{
      users: Array<AdminUser & { role: AdminRole }>;
      total_count: number;
    }>>('/api/admin/auth/users/'),

  createUser: (userData: {
    username: string;
    password: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    role: 'admin' | 'manager' | 'kitchen' | 'operator';
  }) =>
    apiClient.post<ApiResponse<{
      user: AdminUser & { role: AdminRole };
    }>>('/api/admin/auth/users/create/', userData),
};
